import { render } from "./GestisciSolleciti.vue?vue&type=template&id=72aebd8a&scoped=true"
import script from "./GestisciSolleciti.vue?vue&type=script&lang=js"
export * from "./GestisciSolleciti.vue?vue&type=script&lang=js"

import "./GestisciSolleciti.vue?vue&type=style&index=0&id=72aebd8a&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72aebd8a"]])

export default __exports__